import { createClient } from 'contentful';
import { getConfig } from 'config.js';

// Action names are exported for reducers and maintained here

export const ERROR = 'PROJECT::ERROR';
export const LOADING = 'PROJECT::LOADING';
export const LOADED = 'PROJECT::LOADED';
export const UPDATE = 'PROJECT::UPDATE';

// Config

const TOKEN = getConfig('API_TOKEN');
const SPACE_ID = getConfig('API_ID');
const CONTENT_TYPE = 'project'; // 2wKn6yEnZewu2SCCkus4as

// Contentful client

const client = createClient({
    space: SPACE_ID,
    accessToken: TOKEN
});

// Synchronous actions

export function loading(bool) {
    return {
        type: LOADING,
        isLoading: bool
    };
}

export function loaded(project) {
    return {
        type: LOADED,
        payload: project
    };
}

export function failed(bool) {
    return {
        type: ERROR,
        error: bool
    };
}

// Asynchronous actions

export function fetchProject(slug) {
    return dispatch => {
        dispatch(loading(true));
        client
            .getEntries({
                'fields.slug': slug,
                content_type: CONTENT_TYPE
            })
            .then(response => {
                dispatch(loading(false));
                dispatch(loaded(response.items[0].fields));
                window.prerenderReady = true;
            })
            .catch(error => {
                dispatch(loading(false));
                dispatch(failed(true));
            });
    };
}



// WEBPACK FOOTER //
// ./src/data/actions/project.js